import React, {
    useRef,
    useEffect
} from "react";

import {
    TransformWrapper,
    TransformComponent
} from "react-zoom-pan-pinch";

export default function FloorCanvas({
    workplaces,
    clickStates,
    showUnprocessed,
    handleDeskClick,
    getFillColor,
    imgUrl,
    floorPlanWidth,
    floorPlanHeight,
    containerRef
}) {

    const transformRef =
        useRef(null);

    /**************************************************************************
     * AUTO FIT FLOORPLAN
     *************************************************************************/

    useEffect(function () {

        if (
            !transformRef.current ||
            !containerRef.current ||
            !floorPlanWidth ||
            !floorPlanHeight
        ) {
            return;
        }

        const timer = setTimeout(function () {

            const containerWidth =
                containerRef.current.clientWidth;

            const containerHeight =
                containerRef.current.clientHeight;

            const scaleX =
                containerWidth / floorPlanWidth;

            const scaleY =
                containerHeight / floorPlanHeight;

            const scale =
                Math.min(scaleX, scaleY) * 0.95;

            transformRef.current.setTransform(
                0,
                0,
                scale,
                0
            );

            transformRef.current.centerView(
                scale,
                0
            );

        }, 120);

        return function () {

            clearTimeout(timer);
        };

    }, [
        floorPlanWidth,
        floorPlanHeight,
        workplaces.length
    ]);

    /**************************************************************************
     * RENDER
     *************************************************************************/

    return (

        <div
            ref={containerRef}
            style={{
                flex: 1,
                overflow: "hidden",
                position: "relative"
            }}
        >

            <TransformWrapper

                ref={transformRef}

                minScale={0.02}

                maxScale={60}

                centerOnInit={false}

                centerZoomedOut={true}

                limitToBounds={false}

                wheel={{
                    step: 0.1
                }}

                doubleClick={{
                    disabled: true
                }}

                pinch={{
                    step: 5
                }}

            >

                <TransformComponent
                    wrapperStyle={{
                        width: "100%",
                        height: "100%"
                    }}
                >

                    <svg
                        width={floorPlanWidth}
                        height={floorPlanHeight}
                    >

                        {imgUrl && (

                            <image
                                href={imgUrl}
                                width={floorPlanWidth}
                                height={floorPlanHeight}
                            />
                        )}

                        {workplaces.map(function (desk) {

                            if (!desk.svg) {

                                return null;
                            }

                            return (

                                <g
                                    key={desk.id}
                                    onClick={function (e) {

                                        handleDeskClick(
                                            desk,
                                            e
                                        );
                                    }}
                                >

								<path
								    d={desk.svg}
								    fill={
								        showUnprocessed &&
								        !clickStates[desk.id]
								            ? "#ff6600"
								            : getFillColor(desk)
								    }
								    style={
								        showUnprocessed &&
								        !clickStates[desk.id]
								            ? {
								                animation: "unprocessedPulse 1.4s ease-in-out infinite"
								            }
								            : {}
								    }
								/>

                                </g>
                            );
                        })}

                    </svg>

                </TransformComponent>

            </TransformWrapper>

        </div>
    );
}